import { apiJson, replaceUserEndpoint } from './userEndpoint';

export async function fetchUserFitnessProfiles({ userId, endpoint, csrfToken }) {
	const url = replaceUserEndpoint(endpoint, { userId });
	return apiJson(url, { csrfToken }).then((r) => r.data || []);
}

export async function updateFitnessProfile({ userId, fitnessProfileId, endpoint, csrfToken, payload }) {
	const url = replaceUserEndpoint(endpoint, { userId, fitnessProfileId });
	const data = await apiJson(url, {
		method: 'PATCH',
		csrfToken,
		body: { fitness_profile: payload }
	});
	return data.data;
}
